"use client";

import React from "react";
import styles from "./styles.module.scss";

export const ButtonLoader: React.FC<{ size?: number; color?: string }> = ({
  size = 24,
  color = "#fff",
}) => {
  return (
    <div
      className={styles.spinner}
      style={{
        width: size,
        height: size,
        borderColor: `${color} transparent transparent transparent`,
      }}
    />
  );
};
